// extracted by mini-css-extract-plugin
export default {"div":"UserMenu_div__FYCVR","ul":"UserMenu_ul__7Ti7B","li":"UserMenu_li__oQQqK","rotate":"UserMenu_rotate__deyjv","link":"UserMenu_link__PXD-D"};